/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"(optional)\"]}");
//# sourceMappingURL=messages.mjs.map